import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customLogout } from "../Redux/features/User/userSlice";
import axiosInstance from "../Redux/interceptor";
import { sessionDebugEnabled } from "../utils/sessionDebug";
import { redirectToRoleSignIn } from "../utils/signInRedirect";

const useLogout = () => {
  const dispatch = useDispatch();
  const role = useSelector((state) => state.user.user?.role);

  const handleLogout = useCallback(async () => {
    try {
      await axiosInstance.post("/auth/logout");
      if (sessionDebugEnabled()) {
        console.info(
          `[session] ${new Date().toISOString()} logout POST ok (server session killed)`
        );
      }
    } catch (err) {
      // Clear state even if server call fails
      if (sessionDebugEnabled()) {
        console.info(
          `[session] ${new Date().toISOString()} logout POST FAILED, clearing local state anyway`,
          { status: err?.response?.status, message: err?.message }
        );
      }
    }
    dispatch(customLogout());
    // Land on the role's own sign-in (clean URL — deliberate logout keeps no
    // return path)
    await redirectToRoleSignIn(role);
  }, [dispatch, role]);

  return handleLogout;
};

export default useLogout;
